import { render, staticRenderFns } from "./SharingRecord.vue?vue&type=template&id=ed8a6b1a"
import script from "./SharingRecord.vue?vue&type=script&lang=js"
export * from "./SharingRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports